import {put, delay, call} from 'redux-saga/effects';
import {setNotificationError} from '../notification';

const DELAY = 120000;
const MAX_TRIES = 6;

export type SecondArg<T> = T extends (f: unknown, s: infer R) => unknown ? R : never;

export function* payloadGenerator<T>(
    action: Function,
    predicate: Function,
    request: SecondArg<typeof call>,
    params: T,
    tries = MAX_TRIES,
    delayTime = DELAY
) {
    try {
        while (true) {
            const response = yield call(request, params);

            yield put(action(response));

            if (!predicate(response) || --tries <= 0) break;

            yield delay(delayTime / tries ** 2);
        }
    } catch (error) {
        yield put(setNotificationError(error.message));
    }
}
